import {SheetManagerImpl} from "@xivgear/core/persistence/saved_sheets";

export const SHEET_MANAGER = new SheetManagerImpl(localStorage);

